/*
 * ===============================================================================================================
 *                                Copyright 2025, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const ADD_SUBSCRIPTIONS = 'Add Topic Subscriptions';
export const BACK = 'Back';
export const SUBSCRIBE = 'Subscribe';
export const SUBSCRIPTIONS = 'Subscriptions';
export const TOPICS_LIST = 'Topics List';
export const SELECTED = 'Selected';
export const DROPDOWN_WIDTH = 300;
export const DROPDOWN_MAX_HEIGHT = 350;
export const EMPTY_HEADER = 'No Topic available for subscription';
export const NAME = 'Topic Name';
export const ACCESS = 'Topic Access';
export const ACCESS_LABELS = {
  PRODUCER: 'Producer',
  CONSUMER: 'Consumer'
};
export const PRODUCER = 'PRODUCER';
export const CONSUMER = 'CONSUMER';
export const MAX_TOPICS_SELECTION = 20;
export const RESTRICTION_MESSAGE = `${MAX_TOPICS_SELECTION} is the maximum limit for Topic subscription`;
export const ROWS_PER_PAGE_LABEL = 'Rows per page:';
export const UNSUCCESSFUL_SUBSCRIPTION_TITLE = 'Subscription unsuccessful';
export const UNSUCCESSFUL_SUBSCRIPTION_MESSAGE = 'Subscription was unsuccessful for these Topics:';
export const ERROR_MACHINE_NOT_FOUND = 'Machine not found';
export const ERROR_WHILE_FETCHING_DATA = 'Error while fetching data {0}';
export const SELECTED_OF = 'selected of';
export const TOPIC_SUBSCRIBE_WARN = 'Please assign topic access to all selected topics';
export const TOPICS_SUBSCRIBED_SUCCESSFULLY = 'Topics subscribed successfully';
export const UNSUCCESSFUL_TOPIC_SUBSCRIBE_MESSAGE = 'Failed to subscribe to selected topics: {0}';
